import React from 'react'
import Caraousel from '../common/caraousel';
import ArboristWork from './arboristWork';
import Header from './header';
import Leader from "./leader"
import Services from './services';
import Visit from "./visit";
import Contact from './contact';

const home = () => {
  return (
    <div>
        <Header />
        <Caraousel />
        <ArboristWork />
        <Leader />
        <Services/>
        <Visit/>
        <Contact/>
 
    </div>
  )
}

export default home